import api from '@/services/api/config';

const path = 'v1/lieferschein';

export default {
  get: (page = 0, size = 20, sort = null, desc = null, lieferant = null, rechnungsnummer = null, bezahlt = null, jahr = null) => api.get(
    `${path}`,
    {
      params: {
        page,
        size,
        sort,
        desc,
        lieferant,
        rechnungsnummer,
        bezahlt,
        jahr,
      },
    },
  ),
  getUnzugeordnet: (page, size, sort, desc) => api.get(`${path}/unzugeordnet`, {
    params: {
      page, size, sort, desc,
    },
  }),
  getFromAbteilung: (abteilungId, page, size, sort, desc) => api.get(`${path}/abteilung/${abteilungId}`, {
    params: {
      page, size, sort, desc,
    },
  }),
  getArchiv: (page, size, sort, desc, search) => api.get(`${path}/archiv`, {
    params: {
      page, size, sort, desc, search,
    },
  }),
  getAbgelehnt: (page, size, sort, desc) => api.get(`${path}/abgelehnt`, {
    params: {
      page, size, sort, desc,
    },
  }),
  getExportiert: (page, size, sort, desc) => api.get(`${path}/exportiert`, {
    params: {
      page, size, sort, desc,
    },
  }),
  getGeloescht: (page, size, sort, desc) => api.get(`${path}/geloescht`, {
    params: {
      page, size, sort, desc,
    },
  }),
  getById: (id) => api.get(`${path}/${id}`),
  put: (id, eingangsrechnung, skip_pdf = false) => api.put(`${path}/${id}`, eingangsrechnung, { params: { skip_pdf } }),
  delete: (id) => api.delete(`${path}/${id}`),
  zuordnen: (id, abteilung) => api.patch(`${path}/${id}`, { abteilung }),
  freigeben: (id) => api.patch(`${path}/freigeben/${id}`),
  wiederherstellen: (id) => api.patch(`${path}/wiederherstellen/${id}`),
  ablehnen: (id, grund) => api.patch(`${path}/ablehnen/${id}`, null, { params: { grund } }),
  ablehnenStornieren: (id) => api.delete(`${path}/ablehnen/${id}`),
  toggleBezahlt: (id) => api.patch(`${path}/bezahlt/${id}`),
  statistik: () => api.get(`${path}/statistik`),
  export: () => api.get(`${path}/export`),
  getImportStatistik: () => api.get(`${path}/import/statistik`),
  importLieferscheine: () => api.post(`${path}/import`),

  archivieren: (id) => api.patch(`${path}/${id}/archivieren`),
  zurueckAnAbteilungGeben: (id) => api.patch(`${path}/${id}/zurueck-zu-abteilung`),
};
